module.exports = [{
      plugin: require('../../../../../../../mnt/webapps/punch-in-suite/punchin-user-frontend/node_modules/gatsby-plugin-material-ui/gatsby-browser.js'),
      options: {"plugins":[],"pathToEmotionCacheProps":""},
    },{
      plugin: require('../../../../../../../mnt/webapps/punch-in-suite/punchin-user-frontend/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Punch-in Employees Portal","short_name":"Punch-in","start_url":"/","background_color":"#4C1D95","theme_color":"#5B21B6","theme_color_in_head":true,"display":"minimal-ui","icon":"src/images/punchin-icon.png","icon_options":{"purpose":"any maskable"},"legacy":true,"include_favicon":true,"cache_busting_mode":"query","crossOrigin":"anonymous","cacheDigest":"5aa01eb8e0e0891e9347ef69a23b721c"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../../../../../../mnt/webapps/punch-in-suite/punchin-user-frontend/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
